import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* home*/
const Home = _import('page/home');

/* account*/
const Account = _import('page/account');

/* cash*/
const Cash = _import('page/cash');

/* operator*/
const Operator = _import('page/operator');

/* search*/
const Search = _import('page/search');

/* recharge*/
const Recharge = _import('page/recharge');

/* login */
const Login = _import('login/index');

/* error page */
const Err404 = _import('404');

/* transaction detail */
const Transaction = _import('page/transaction')
const RechargeRecord = _import('page/rechargeRecord')
const WithdrawRecord = _import('page/withdrawRecord')

Vue.use(Router);

 /**
  * icon : the icon show in the sidebar
  * hidden : if `hidden:true` will not show in the sidebar
  * redirect : if `redirect:noredirect` will not redirct in the levelbar
  * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
  * meta : `{ role: ['admin'] }`  will control the page role
  **/
export const constantRouterMap = [
  { path: '/login', component: Login, hidden: true },
  { path: '/404', component: Err404, hidden: true },
  { path: '/', component: Home },
  { path: '/account', component: Account },
  { path: '/cash', component: Cash },
  { path: '/operator', component: Operator },
  { path: '/search', component: Search },
  { path: '/recharge', component: Recharge },
  { path: '/transaction', component: Transaction },
  { path: '/recharge/rechargeRecord', component: RechargeRecord },
  { path: '/cash/withdrawRecord', component: WithdrawRecord }
]

export default new Router({
  /* mode: 'history', //后端支持可开 */
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: constantRouterMap
});

export const asyncRouterMap = [
  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'Example',
  //   icon: 'zujian',
  //   children: [
  //     { path: 'index', component: Form, name: 'Form', icon: 'zonghe' }
  //   ]
  // },

  // {
  //   path: '/table',
  //   component: Layout,
  //   redirect: '/table/index',
  //   name: 'Table',
  //   icon: 'tubiaoleixingzhengchang',
  //   noDropdown: true,
  //   children: [{ path: 'index', component: Table, name: 'Table', meta: { role: ['admin'] } }]
  // },

  // { path: '*', redirect: '/404', hidden: true }
];



// WEBPACK FOOTER //
// ./src/router/index.js